var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "练习完成",
        visible: _vm.visibleProxy,
        width: "460px",
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        }
      }
    },
    [
      _c("div", { staticClass: "tsd-header" }, [
        _c("p", { staticClass: "tsd-level" }, [
          _vm._v("得分："),
          _c("span", { staticClass: "tsd-score" }, [
            _vm._v(_vm._s(_vm.computedScore))
          ]),
          _vm._v(" 分")
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "tsd-pass", class: { "is-pass": _vm.computedPassed } },
          [
            _vm._v(
              _vm._s(
                _vm.computedPassed ? "通过，干得漂亮！" : "未通过，继续加油哦！"
              )
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tsd-table" }, [
        _c("table", { attrs: { cellspacing: "0", cellpadding: "0" } }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("操作项目")]),
              _vm._v(" "),
              _c("th", { staticClass: "col-score" }, [_vm._v("得分")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.computedItems, function(row, idx) {
                return _c(
                  "tr",
                  { key: idx },
                  [
                    row.isSection
                      ? [
                          _c(
                            "td",
                            {
                              staticClass: "is-advance",
                              attrs: { colspan: "2" }
                            },
                            [_vm._v(_vm._s(row.label))]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-score" })
                        ]
                      : [
                          _c("td", [_vm._v(_vm._s(row.label))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-value" }, [
                            _vm._v(_vm._s(row.value))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-score" }, [
                            _vm._v(_vm._s(_vm.formatScore(row.score)))
                          ])
                        ]
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.actionTypeMap && _vm.actionTypeMap.length > 0
                ? _vm._l(_vm.actionTypeMap, function(actionType, index) {
                    return _c("tr", { key: actionType.actionType }, [
                      index === 0
                        ? _c(
                            "td",
                            {
                              staticStyle: { color: "red" },
                              attrs: { rowspan: _vm.actionTypeMap.length }
                            },
                            [_vm._v("高级操作")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", { staticClass: "col-value" }, [
                        _vm._v(
                          "漏掉" +
                            _vm._s(
                              actionType.actionType == "TRANSFER_AFTER_SALE"
                                ? "转接售后"
                                : actionType.actionType == "REMARK_MODIFY"
                                ? "添加备注"
                                : ""
                            ) +
                            _vm._s(actionType.times) +
                            "次"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "col-score" }, [
                        _vm._v("-" + _vm._s(actionType.points))
                      ])
                    ])
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("tfoot", [
            _c("tr", [
              _c("td", { staticClass: "total", attrs: { colspan: "2" } }, [
                _vm._v("总分")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "col-score" }, [
                _vm._v(_vm._s(_vm.computedScore))
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { plain: "" }, on: { click: _vm.onRestart } },
            [_vm._v("再练一次")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onViewResult } },
            [_vm._v("查看结果")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dddafd34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dddafd34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/components/TrainScoreDialog.vue
// module id = 1714
// module chunks = 0